__turbopack_context__.v({
  "correct-highlight": "EnhancedHotSpot-module__vpdqnq__correct-highlight",
  "incorrect-highlight": "EnhancedHotSpot-module__vpdqnq__incorrect-highlight",
  "missed-highlight": "EnhancedHotSpot-module__vpdqnq__missed-highlight",
  "user-highlight": "EnhancedHotSpot-module__vpdqnq__user-highlight",
});
